const empty = Symbol("empty");

function filterMenu(item, layout) {
  if (Array.isArray(item)) {
    return item.map((i) => filterMenu(i, layout)).filter((i) => i !== empty);
  }

  const filtered =
    item !== undefined &&
    item !== null &&
    Object.hasOwnProperty.call(item, "layouts") &&
    Array.isArray(item.layouts) &&
    !item.layouts.includes(layout);

  if (filtered) {
    return empty;
  }

  if (typeof item === "object" && item !== null) {
    return Object.entries(item).reduce((acc, [key, value]) => {
      const filteredValue = filterMenu(value, layout);
      return filteredValue === empty ? acc : { [key]: filteredValue, ...acc };
    }, {});
  }

  return item;
}

export default function filterMenuWrapper(item, layout) {
  /**
   * Use this to recursively filter out objects that have a "layouts" array
   * key/value pair not containing the layout specified via parameter "layout".
   * If no layouts key is present (or the value is not an array), the object
   * will not be filtered out.
   *
   * eg: filterMenuWrapper([
   *       { layoutsSpecified: false },
   *       { layouts: [MOBILE] },
   *     ], DESKTOP)
   *
   *     becomes [
   *       { layoutsSpecified: false },
   *     ]
   */
  const result = filterMenu(item, layout);
  return result === empty ? null : result;
}
